import { GetterTree } from 'vuex';
import { RootState } from '../types';

export const getters: GetterTree<RootState, RootState> = {
  getTree: (state) => state.tree,
  getSearchInfo: (state) => state.searchResult,
  getBreadcrumbs: (state) => state.breadcrumbs,
  getSelectedLanguagesPack: (state) => state.selectedLanguagesPack,
  getContent: (state) => state.content,
  getLocale: (state) => state.locale,
  getCountryCode: (state) => state.country_code,
  contentLoading: (state) => state.contentLoading,
  pageIncludesCodeExamples: (state) => state.pageIncludesCodeExamples,
  getWithByLink: (state) => state.withByLink,
};
